import { render, staticRenderFns } from "./qrcode-paper.vue?vue&type=template&id=94b5b700&scoped=true&"
import script from "./qrcode-paper.vue?vue&type=script&lang=js&"
export * from "./qrcode-paper.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-paper.vue?vue&type=style&index=0&id=94b5b700&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5b700",
  null
  
)

export default component.exports